import React, { Component } from 'react';
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../../store';
import FacturasGlobalesList from './components/FacturasGlobalesList';
import SearchByDatesAndKeyword from '../../../shared/SearchByDatesAndKeyword';
import FacturasGlobalesItemActions from './components/FacturasGlobalesItemActions';

class FacturasGlobales extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Facturas Globales');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  };

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/modulos/fpg/tickets/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    return (
      <>
        <Row>
          <Col
            sm="auto"
            md="8"
            className="mb-2"
          >
            <div>
              {selectedRowKeys.length > 0 && (
                <div className="mr-3 d-inline-flex pb-2">
                  <FacturasGlobalesItemActions
                    selectedRowKeys={selectedRowKeys}
                    selectedRows={selectedRows}
                    alignRight={false}
                  />
                </div>
              )}

              {selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={from}
                  to={to}
                  search={search}
                  onDateChange={this.handleOnDateChange}
                  onKeywordChange={this.handleOnKeywordChange}
                />
              )}
            </div>
          </Col>
        </Row>

        {Guardian.allows('factura.global.listar') && (
          <FacturasGlobalesList
            onRowClick={this.handleOnRowClick}
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return store.modulo.fpg.list;
};

const mapActions = (actions) => {
  return actions.modulo.fpg.list;
};

export default connect(useStore, mapState, mapActions)(FacturasGlobales);
